module.exports = __webpack_public_path__ + "media/images/result_sets/circles/4n5n1n2n-23620d417c7f10073bd482ee6bee71c0.svg";